<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar color="primary">
          axios eg
        </v-toolbar>
      </v-flex>
      <v-flex xs3>
        <v-card>
          <v-card-title primary-title>
            <div>
              create
            </div>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="textCreate"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="primary">submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      textCreate: ''
    }
  }
}
</script>
